import React from 'react'
import { PageHead } from '@fs/zion-head'
import { useTranslation } from 'react-i18next'
import { PageWrapper as IdentityPageWrapper } from '@fs/identity.js'

export default function PageWrapper({ children }) {
  const { t } = useTranslation()
  return (
    <>
      <PageHead
        title={t('sign-up.heading')}
        // relying on default FS description for now
        description=""
      />
      <IdentityPageWrapper {...{ maxWidth: 'nano', growY: true, children }} />
    </>
  )
}
